<template>
  <v-app-bar
      app
  >
    <v-container class="py-0 fill-height align-center">
        <v-toolbar-title>بےبی سٹورم</v-toolbar-title>

        <v-spacer/>
        <v-toolbar-items>
          <v-btn
              text
              @click="$emit('toggleTheme')"
          >
            <v-icon>
              {{ getLogo }}
            </v-icon>
          </v-btn>
        </v-toolbar-items>
    </v-container>
  </v-app-bar>
</template>

<script>
export default {
  name: "AppBar",
  computed: {
    getLogo() {
      return (this.$vuetify.theme.dark) ? "mdi-white-balance-sunny" : "mdi-weather-night"
    }
  },
}
</script>